import React, { useRef, useEffect, useState } from "react";
import "./AppPromotionSection.css";
import { GrAppleAppStore } from "react-icons/gr";
import { BiLogoPlayStore } from "react-icons/bi";
import { FaCheck } from "react-icons/fa";
import mockupImage from "./01.png";

const AppDownload = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(true);
  const featureRefs = useRef([]);
  const features = [
    "Consulta de consumo em tempo real",
    "Pagamento de faturas",
    "Solicitar suporte técnico",
    "Teste de velocidade integrado",
  ];
  const [checkedItems, setCheckedItems] = useState(features.map(() => false));

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const items = featureRefs.current.filter(Boolean);
    if (!items.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = Number(entry.target.dataset.index);
          setCheckedItems((prev) => {
            if (prev[index]) return prev;
            const next = [...prev];
            next[index] = true;
            return next;
          });
        });
      },
      { threshold: 0.6 },
    );

    items.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="app-promotion-section">
      <div className="phone-mockup">
        <div className="phone-wrapper">
          <div className={`phone-back ${visible ? "animate" : ""}`} />
          <div className={`phone-back-2 ${visible ? "animate" : ""}`} />
          <div className={`phone-back-3 ${visible ? "animate" : ""}`} />
          <img
            src={mockupImage}
            className="app-image"
            alt="App Sette Fibra"
            loading="lazy"
            decoding="async"
          />
          <div className="glow-circle"></div>
        </div>
      </div>

      <div className="promo-content">
        <h2>
          Baixe o App <span className="app-title-gradient">SETTE Fibra</span>
        </h2>
        <p>
          Tenha acesso ao seu consumo, faturas, suporte técnico e muito mais na
          palma da sua mão. Nosso aplicativo facilita a gestão da sua internet.
        </p>
        <ul className="promo-features">
          {features.map((feature, index) => (
            <li
              key={feature}
              data-index={index}
              ref={(el) => {
                featureRefs.current[index] = el;
              }}
              className={`feature-item ${checkedItems[index] ? "checked" : ""}`}
            >
              <span className="feature-icon">
                <FaCheck />
              </span>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <div className="store-buttons">
          <a
            href="https://apps.apple.com/br/app/sette-fibra/id6711349663"
            className="store-button"
          >
            <span className="store-icon">
              <GrAppleAppStore />
            </span>
            <span>
              Disponível na <strong>App Store</strong>
            </span>
          </a>
          <a href="https://abrir.link/feCmF" className="store-button">
            <span className="store-icon">
              <BiLogoPlayStore />
            </span>
            <span>
              Disponível no <strong>Google Play</strong>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AppDownload;
